import { createFileRoute } from '@tanstack/react-router';
import VehicleVerification from '../../components/InternalPortal/VehicleVerification/VehicleVerification';
import { PERMISSION_INTERNAL_PORTAL } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/vehicle-verification')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_INTERNAL_PORTAL, ['read'], '/unauthorized', context);

    return {
      ...context,
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: VehicleVerificationRoute,
});

function VehicleVerificationRoute() {
  return <VehicleVerification />;
}
